import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";

/**
 * Media Value donut: TV, Press, Earned (reach based) and Tracked (estimated reach).
 * Follows the PA dropdown (rightsholder / league). Earned appears on Portfolio only.
 */
const usePAMediaValue = ({ rightsholderId = 0, parentTenantId = null } = {}) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const enabled = !!(startDate && endDate);

  let since;
  let until;
  if (enabled) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: ["PA_MEDIA_VALUE", tenant.id, rightsholderId, parentTenantId, startDate, endDate],
    queryFn: () =>
      ApiService.getPlacementAnalysisMediaValue({
        rightsholderId,
        parentTenantId,
        since,
        until,
      }),
    select: (res) => res.data,
    enabled,
    placeholderData: { data: { total: 0, trend: 0, series: [] } },
  });
};

export default usePAMediaValue;
